// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3DvQt","row":"ProcedureTreatmentSummary_row__gNMYe"};